import { PRODUCTION_APP_ENV_STRING } from "@/lib/constants";

const TEST_TOKEN = 'when-course-human-events';

export function isValidDevMembershipToken(token: string) {
  if(process.env.NODE_ENV === 'development' || process.env.APP_ENV !== PRODUCTION_APP_ENV_STRING) {
    return token.toLowerCase() === TEST_TOKEN
  }

  return false
}
